import MapListOption from '../components/MapListOption';

const MapListOptionContainer = () => {
  return <MapListOption />;
};

export default MapListOptionContainer;
